import { JarvisProduct } from '@vfde-sails/availability';
import { CmsPlaceholder } from '../enum';
import { TariffMinimumDownload } from '../enums/content';
import { isMinimumDownloadKey } from './typeGuard';

/**
 * Converts any number or string into a text which can be displayed on frontend
 *
 * @param price - Price to convert
 * @param showEmptyCents - Show the ",00" part?
 * @returns Price string
 */
export const convertToPriceString = (price: number | string, showEmptyCents = false) => {
    const priceNumber = +(price.toString().replace(',', '.'));

    return priceNumber.toFixed(!showEmptyCents && Number.isInteger(priceNumber) ? 0 : 2).replace('.', ',');
};

/**
 * Replaces all tariff related placeholders in a text.
 */
export const replaceTariffPlaceholders = (text: string, tariff: JarvisProduct) => text
    .replaceAll(CmsPlaceholder.Name, tariff.name)
    .replaceAll(CmsPlaceholder.Price, convertToPriceString(tariff.price.value))
    .replaceAll(CmsPlaceholder.Download, tariff.download.toString())
    .replaceAll(CmsPlaceholder.Duration, tariff.duration.toString());

/**
 * Replaces all placeholders in the tariff subline tooltip
 */
export const replaceTariffTooltipPlaceholders = (text: string, { id, download }: JarvisProduct) => {
    const minDownloadValue = isMinimumDownloadKey(id) ? TariffMinimumDownload[id].toString() : null;

    text = text.replaceAll(CmsPlaceholder.Download, download.toString());

    return minDownloadValue
        ? text.replaceAll(CmsPlaceholder.MinDownload, minDownloadValue)
        : text;
};
